import { Button } from '@mantine/core';
import { ButtonProps } from '@mantine/core';

interface CancelSubscriptionButtonProps extends ButtonProps {
    onClick: () => void;
    loading?: boolean;
}

export const CancelSubscriptionButton = ({ onClick, loading, ...props }: CancelSubscriptionButtonProps) => (
    <Button
        color="red"
        variant="light"
        onClick={onClick}
        loading={loading}
        {...props}
    >
        Cancel Subscription
    </Button>
);